import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasReservationSearchValueObject extends ValueObject {
  #hasReservation

  constructor({hasReservation}) {
    super()
    this.#hasReservation = hasReservation
  }

  static create({hasReservation}) {
    return new FilterHasReservationSearchValueObject({
      hasReservation: FilterBooleanSearchValueObject.create(hasReservation)
    })
  }

  static createWithDefaultValue({config, hasReservation}) {
    const {DEFAULT_HAS_RESERVATION_SEARCH} = config.get('searchFilters')

    return new FilterHasReservationSearchValueObject({
      hasReservation: FilterBooleanSearchValueObject.create({
        boolean: hasReservation ?? DEFAULT_HAS_RESERVATION_SEARCH
      })
    })
  }

  static createQueryParams({config, hasReservation}) {
    const {DEFAULT_HAS_RESERVATION_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasReservationSearchValueObject({
      hasReservation: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_RESERVATION],
        value: hasReservation === DEFAULT_HAS_RESERVATION_SEARCH ? null : hasReservation
      })
    })
  }

  get isEmpty() {
    return this.#hasReservation.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasReservation.queryParam})
    }
  }

  get value() {
    return this.#hasReservation.value
  }

  toJSON() {
    return {
      hasReservation: this.#hasReservation.toJSON()
    }
  }
}
